module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-11-e0ca87a507da16a149c57b607ff6c2bf.svg";